// Station configuration for multi-station support
// Each station defines its belt/team layout, naming, MU mappings, and export groups

const DEN_CONFIG = {
  stationCode: 'DEN',
  stationName: 'Denver',
  activeBelts: 12,
  conflictWindow: 3,
  maxFlightsPerHour: 3,
  beltPairs: [[1, 2], [3, 4], [5, 6], [7, 8], [9, 10], [11, 12]],
  beltSchedule: (() => {
    const schedule = {};
    for (let i = 1; i <= 12; i++) {
      schedule[String(i)] = { openTime: '03:00', closeTime: '02:59' };
    }
    return schedule;
  })(),
  muAssignmentTimeOverride: {
    enabled: false,
    openTime: '01:30',
    closeTime: '01:25'
  },
  makeupUnits: {
    '1': '1E3MU3',
    '2': '1E3MU3',
    '3': '1E3MU2',
    '4': '1E3MU2',
    '5': '1E3MU1',
    '6': '1E3MU1',
    '7': '2EMU4',
    '8': '2EMU4',
    '9': '2EMU3',
    '10': '2EMU3',
    '11': '2E3MU1',
    '12': '2E3MU1'
  },
  pierSupport: {
    '1E3MU3': '3',
    '1E3MU2': '4',
    '1E3MU1': '5',
    '2EMU4': '8',
    '2EMU3': '9',
    '2E3MU1': '0'
  },
  beltNames: {
    '1': 'Belt 1 3A',
    '2': 'Belt 2 3B',
    '3': 'Belt 3 4A',
    '4': 'Belt 4 4B',
    '5': 'Belt 5 5A',
    '6': 'Belt 6 5B',
    '7': 'Belt 7 8A',
    '8': 'Belt 8 8B',
    '9': 'Belt 9 9A',
    '10': 'Belt 10 9B',
    '11': 'Belt 11 0A',
    '12': 'Belt 12 0B'
  },
  exportGroups: [
    { name: 'MOD1', title: 'MOD 1 - Belts 1-6', color: 'FFC0C0C0', beltRange: [1, 6] },
    { name: 'MOD2', title: 'MOD 2 - Belts 7-12', color: 'FFFF0000', beltRange: [7, 12] }
  ]
};

// East coast destinations (BNA/IND and east) -> D Pod
// Everything else -> C Pod
const MCO_EAST_DESTINATIONS = [
  // Northeast
  'ALB', 'BDL', 'BOS', 'BUF', 'ISP', 'LGA', 'MHT', 'PHL', 'PIT', 'PVD', 'PWM', 'ROC',
  // Mid-Atlantic / DC area
  'BWI', 'DCA', 'IAD', 'RIC', 'ORF',
  // Southeast
  'ATL', 'CHS', 'CLT', 'GSP', 'JAX', 'MYR', 'RDU', 'SAV', 'TYS',
  // Florida (east of BNA)
  'FLL', 'MIA', 'MCO', 'PBI', 'RSW', 'SRQ', 'TPA', 'ECP', 'VPS',
  // Ohio / Michigan / Midwest east of BNA-IND line
  'CLE', 'CMH', 'CVG', 'DTW', 'GRR', 'IND', 'SDF',
  // Tennessee (BNA is the boundary, included in east)
  'BNA',
  // Caribbean / East international
  'AUA', 'GCM', 'HAV', 'MBJ', 'NAS', 'PLS', 'PUJ', 'SJU', 'STT', 'SXM'
];

const MCO_CONFIG = {
  stationCode: 'MCO',
  stationName: 'Orlando',
  activeBelts: 18,
  conflictWindow: 3,
  maxFlightsPerHour: 3,
  beltPairs: [
    // Belt 21: teams 6,7
    [6, 7],
    // Belt 20: all pairs among teams 8,9,10,11
    [8, 9], [8, 10], [8, 11], [9, 10], [9, 11], [10, 11],
    // Belt 14: teams 13,14
    [13, 14],
    // Belt 13: teams 15,16
    [15, 16]
  ],
  beltSchedule: (() => {
    const schedule = {};
    for (let i = 1; i <= 18; i++) {
      schedule[String(i)] = { openTime: '03:00', closeTime: '02:59' };
    }
    return schedule;
  })(),
  muAssignmentTimeOverride: {
    enabled: false,
    openTime: '01:30',
    closeTime: '01:25'
  },
  makeupUnits: {
    '1': '3SP27', '2': '3SP26', '3': '3SP25', '4': '3SP24', '5': '3SP23',
    '6': '3MU21', '7': '3MU21', '8': '3MU20', '9': '3MU20', '10': '3MU20', '11': '3MU20',
    '12': '2MU15', '13': '2MU14', '14': '2MU14', '15': '2MU13', '16': '2MU13',
    '17': '2SP09', '18': '2SP07'
  },
  pierSupport: {
    '3SP27': '9', '3SP26': '8', '3SP25': '7', '3SP24': '6', '3SP23': '5',
    '3MU21': '4', '3MU20': '4',
    '2MU15': '3', '2MU14': '3', '2MU13': '3', '2SP09': '3', '2SP07': '3'
  },
  beltNames: {
    '1': '27',
    '2': '26',
    '3': '25',
    '4': '24',
    '5': '23',
    '6': '21-1',
    '7': '21-2',
    '8': '20 1-1',
    '9': '20 2-1',
    '10': '20 3-1',
    '11': '20 4-1',
    '12': '15',
    '13': '14-1',
    '14': '14-2',
    '15': '13-1',
    '16': '13-2',
    '17': 'SP9',
    '18': 'SP7'
  },
  exportGroups: [
    { name: 'CPod', title: 'C Pod - Teams 1-11', color: 'FFC0C0C0', beltRange: [1, 11] },
    { name: 'DPod', title: 'D Pod - Teams 12-18', color: 'FFFF0000', beltRange: [12, 18] }
  ],
  // Destination-based belt restrictions:
  // Flights whose first destination is in 'destinations' go to belts in 'beltRange'.
  // Flights not matching any rule get the default (first entry with destinations: null).
  destinationBeltGroups: [
    { name: 'CPod', destinations: null, beltRange: [1, 11] },           // default: west
    { name: 'DPod', destinations: MCO_EAST_DESTINATIONS, beltRange: [12, 18] }  // east coast
  ]
};

export const STATION_CONFIGS = {
  DEN: DEN_CONFIG,
  MCO: MCO_CONFIG
};

export const STATION_LIST = [
  { code: 'DEN', name: 'Denver', description: 'Denver International Airport' },
  { code: 'MCO', name: 'Orlando', description: 'Orlando International Airport' }
];
